import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  customLogoutUrl:string = "";
  logoutAllSessions: boolean;
  pending:boolean = false;

  constructor() { }

  redirectToSAMLLogin(){
    if(!this.pending){
      this.pending = true;
      document.location.href = environment.API_URL + 'saml2/authenticate';
    }
  }

  redirectToSAMLLogout(){
    let url: string;
    if(this.customLogoutUrl?.length == 0) {
      url = environment.API_URL + 'logout';
    } else {
       url = this.customLogoutUrl;
    }
    document.location.href = url;
  }

  setRedirectPending(pending:boolean){
    this.pending = pending;
  }

}
